import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
}

/** Spec card surface: rounded-xl, bordered, white/gray-800 (no drop shadow). */
export function Card({ children, className = '' }: CardProps) {
  return (
    <div className={`bg-white rounded-xl border border-gray-200 dark:bg-gray-800 dark:border-gray-700 ${className}`}>
      {children}
    </div>
  );
}

export function CardHeader({ children, className = '' }: CardProps) {
  return (
    <div className={`px-4 py-3 border-b border-gray-200 dark:border-gray-700 ${className}`}>
      {children}
    </div>
  );
}

export function CardContent({ children, className = '' }: CardProps) {
  return (
    <div className={`px-4 py-4 ${className}`}>
      {children}
    </div>
  );
}

export function CardFooter({ children, className = '' }: CardProps) {
  return (
    <div className={`px-4 py-3 border-t border-gray-100 bg-gray-50 rounded-b-xl dark:border-gray-700 dark:bg-gray-800/50 ${className}`}>
      {children}
    </div>
  );
}
